import React from 'react'
import {connect} from 'react-redux'
import {Flex} from '/app/src/component'

import MenuSubTitle from '/app/src/component/Menu/SubTitle';
import DateTime from '/app/src/lib/DateTime';
import {AutoMessageSelector} from '/app/src/model/AutoMessage';
import style from './style.css'
import {H3, P1, ToogleInput, SlideInput, MarkdownDisplay} from '/app/src/component'
import ClientChatMenu from './MainMenu/ClientChatMenu'
import _ from 'lodash'


class AutoMessagePreviewMenu extends React.Component{
    render(){
        let autoMessage = this.props.automessage.toJS()
        if(!autoMessage || _.isEmpty(autoMessage)) return <ClientChatMenu/>;

        let frequency = AutoMessageSelector.getFrequency(this.props.automessage)
        const duration = AutoMessageSelector.getMessageDuration(this.props.automessage)

        switch(frequency){
            case 'once24h': frequency='Varje 24 timmar'; break;
            case 'never': frequency = 'Aldrig'; break;
            case 'always':
            default: frequency = 'Alltid'; break;
        }

        let visitor = autoMessage.message.visitor
        switch(visitor){
            case 'recurring': visitor='Återkommande'; break;
            case 'first': visitor='Första besök'; break;
            case 'all':
            default: visitor='Alla';break;
        }

        try {
            return (
            <Flex column hAlignContent='center' height='100%' w='100%'>
                <MenuSubTitle text='Automeddelande' to='/clientChat/autoMessage' svgSrc='/images/Menu_ClientChatAutomessage_L.svg'
                svgfill='#f64b7f'
                />
                <div style={{overflowY: 'auto', width: '100%', paddingLeft: '10%', height: '100%'}} >

                <Flex column width='90%' >
                    <H3 marginTop='20px'>Titel</H3>
                    <P1 marginTop='10px'>
                        {autoMessage.message.message.title}
                    </P1>
                    <Flex className={style.PriorityVisitorWrapper} marginBottom='10px' wrap>
                        <Flex basis='auto' column grow>
                            <H3 marginTop='20px' marginBot='10px'> Sida(Url) </H3>
                            <P1>{autoMessage.message.url}</P1>
                        </Flex>
                        <Flex basis='50%' column>
                            <H3 marginTop='20px' marginBot='10px'> Frekvens </H3>
                            <P1>{frequency}</P1>
                        </Flex>
                    </Flex>

                    <Flex className={style.PriorityVisitorWrapper}>
                        <Flex basis='50%' column>
                            <H3> Prioritet </H3>
                            <P1>
                            {parseInt(autoMessage.message.message.priority, 10) + 1}
                            </P1>
                        </Flex>

                        <Flex basis='50%' column>
                            <H3> Visningstid </H3>
                            <P1>
                            {parseInt(duration, 10)}
                            </P1>
                        </Flex>
                    </Flex>

                    <H3 marginTop='10px'>Meddelande</H3>
                    <P1 marginTop='10px'>
                        <MarkdownDisplay text={autoMessage.message.message.message}/>
                    </P1>

                    <H3 marginTop='20px' marginBottom='10px'> Veckodagar </H3>
                    <ToogleInput
                            values={[
                            {value: 0, label: 'Må'},
                            {value: 1, label: 'Ti'},
                            {value: 2, label: 'On'},
                            {value: 3, label: 'To'},
                            {value: 4, label: 'Fr'},
                            {value: 5, label: 'Lö'},
                            {value: 6, label: 'Sö'}
                        ]}
                        active={autoMessage.message.days_of_the_week}
                        name='weekDays'
                        onChange={() => {}}
                    />
                    <Flex grow width='100%'>
                        <Flex column width='80%' className={style.TimeWrapper}>
                            <H3>Tidsintervaller</H3>
                            <Flex column>
                                {this.__renderTimeTrigger(autoMessage.message.time)}
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
                </div>
            </Flex>
        )
        } catch (e) {
            return null;

        }
    }


        __renderTimeTrigger(times){
            let timeTriggers = []

            let __formatLabel = (value) => {
                let time = DateTime.convertMinutesToHour(value)
                time = time.map((value) => {
                    if(value < 10){
                        return '0' + value.toString()
                    }
                    return value.toString()
                })
                time = time.join(':')
                return time
            }

            times.forEach((time, index) => {
                let minValue = time.time_before[0]*60 + time.time_before[1]
                let maxValue = time.time_after[0]*60 + time.time_after[1]
                timeTriggers.push(<SlideInput
                    formatLabel={__formatLabel}
                    minValue={0}
                    maxValue={1439}
                    value={{min: minValue, max: maxValue}}
                    key={index}
                    onChange={()=>{}}
                    step={5}
                    marginTop='35px'
                />
                )
            })
            return timeTriggers
        }
}
function mapStateToProps(state, ownProps){
    let automessage
    try{
        automessage = AutoMessageSelector.getById(state, ownProps.match.params.id)
    }catch(error){
        console.log(error);
    }
    return {
        automessage
    }

}
export default connect(mapStateToProps)(AutoMessagePreviewMenu)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/AutoMessageMenuPreview.js